window.onload = function () {
  $('.device-firmware-checkbox').change(function () {
    let stacks = $('input[rel='+this.id+']');
    stacks.prop('checked', $(this).prop('checked'));
  });

  $('.stack-firmware-checkbox').change(function () {
    let device = $('#'+$(this).attr('rel'));
    let stacks = $('input[rel='+device.prop('id')+']');

    if($(this).prop('checked') === false){
      device.prop('checked', false);
    }
    else if(is_all_checked(stacks)){
      device.prop('checked', true);
    }
  })
};

function is_all_checked(iterable) {
  for(let i = 0; i < iterable.length; ++i){
    let item = iterable[i];
    if($(item).prop('checked') === false){
      return false
    }
  }
  return true;
}